import { theme } from '@kijiji/theme'
import { type MutableRefObject } from 'react'

import {
  AD_REFRESH_COOLDOWN_EXTENDED,
  GPT_COMPONENT_ID,
} from '@/features/advertisement/constants/adSlots'
import { triggerManualAdRefresh } from '@/features/advertisement/utils/triggerManualAdRefresh'
import { getUserDevice } from '@/utils/getUserDevice'
import { isServer } from '@/utils/isSSR'

/**
 * Refreshes skyscraper & mweb leaderboard every 20 listings when scrolling
 * @param inView - Whether the ad is currently in view.
 * @param recentlyRefreshed - A ref object that indicates if the ad was recently refreshed.
 * @returns void
 */
export const handleScrollingAdRefresh = (
  inView: boolean,
  recentlyRefreshed: MutableRefObject<boolean>
) => {
  if (isServer() || recentlyRefreshed.current) return

  const isLargeScreen = window.innerWidth >= theme.breakpoints.large
  const isMobile = getUserDevice().isPhone

  const skyscraperNeedsAdRefresh = inView && isLargeScreen

  // mweb leaderboard is displayed based on device type not viewport size
  const mwebLeaderboardNeedsAdRefresh = inView && isMobile

  if (mwebLeaderboardNeedsAdRefresh) triggerManualAdRefresh(GPT_COMPONENT_ID.MWEB_LEADERBOARD)

  if (skyscraperNeedsAdRefresh) triggerManualAdRefresh(GPT_COMPONENT_ID.SKYSCRAPER)

  // prevent ad refreshes from happening too frequently
  if (mwebLeaderboardNeedsAdRefresh || skyscraperNeedsAdRefresh) {
    recentlyRefreshed.current = true
    setTimeout(() => {
      recentlyRefreshed.current = false
    }, AD_REFRESH_COOLDOWN_EXTENDED)
  }
}
